import ElementBase from './ElementBase';
import ActivityElement from './ActivityElement';
import generateId from '../generateId';
import { plannerComponentTypesEnum } from './enums';
import { sum } from '../functions';

export default class RepeaterElement extends ElementBase {
  // @repeaterElement is a plain object with properties set as desired
  constructor(repeaterElement) {
    const id = (repeaterElement && repeaterElement.id) ? repeaterElement.id : generateId();
    super(plannerComponentTypesEnum.repeater, id);
    this.repeatTimes = 1;
    this.repeatedPlannerComponents = [];
    Object.assign(this, repeaterElement);

    let elements = [];
    if (repeaterElement && repeaterElement.repeatedPlannerComponents) {
      this.repeatedPlannerComponents = [];
      elements = repeaterElement.repeatedPlannerComponents
        .map(element => new ActivityElement(element));
    } else {
      elements.push(new ActivityElement());
    }
    this.repeatedPlannerComponents = this.repeatedPlannerComponents.concat(elements);
  }

  get estimatedLoad() {
    const activityLoads = this.repeatedPlannerComponents.map(
      elementComponent => elementComponent.estimatedLoad,
    );
    return this.repeatTimes * activityLoads.reduce(sum, 0);
  }

  get estimatedDistance() {
    const activityDistances = this.repeatedPlannerComponents.map(
      elementComponent => elementComponent.estimatedDistance,
    );
    return this.repeatTimes * activityDistances.reduce(sum, 0);
  }

  get estimatedDuration() {
    const activityDurations = this.repeatedPlannerComponents.map(
      elementComponent => elementComponent.estimatedDuration,
    );
    return this.repeatTimes * activityDurations.reduce(sum, 0);
  }
}
